import React from 'react';
import { useSite } from '../context/SiteContext';
import { trackContactEvent } from '../utils/trackingEvents';

const WhatsAppButton: React.FC = () => {
  const { whatsappUrl } = useSite();

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Contato via WhatsApp"
      onClick={trackContactEvent}
    >
      <i className="fab fa-whatsapp"></i>

      <style>{`
        .whatsapp-float {
          position: fixed; width: 60px; height: 60px; bottom: 40px; right: 40px;
          background-color: #25d366; color: white; border-radius: 50%;
          text-align: center; font-size: 30px; box-shadow: 2px 2px 3px #999;
          z-index: 1050; display: flex; align-items: center; justify-content: center;
          text-decoration: none; transition: all 0.3s ease;
          animation: float 3s ease-in-out infinite;
        }
        .whatsapp-float:hover { background-color: #128c7e; color: white; transform: scale(1.1); }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
          100% { transform: translateY(0px); }
        }
        @media (max-width: 767px) {
          .whatsapp-float { width: 50px; height: 50px; bottom: 20px; right: 20px; font-size: 24px; }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppButton;
